/**
 * Formats time in minutes to a human-readable string
 * @param minutes - Time in minutes
 * @returns Formatted time string (e.g., "30 min", "1 hr", "1 hr 25 min")
 */
export const formatTime = (minutes: number): string => {
  if (minutes < 60) {
    return `${minutes} min`;
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (remainingMinutes === 0) {
    return `${hours} hr`;
  }

  return `${hours} hr ${remainingMinutes} min`;
};